import FastCashLog from './FastCashLog';

export default FastCashLog;
